import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';

import Penalty from './Penalty';

const useStyles = makeStyles(() => ({
  penaltyContainer: {
    padding: '0px 12px !important',
  },
  title: {
    textAlign: 'center',
    padding: '0px !important',
  },
}));

function Penalties({ teams, players, penalties }) {
  const classes = useStyles();
  return (
    <Grid container spacing={3}>
      <Grid className={classes.title} item xs={12}>
        <Typography variant="overline" component="p">Penalty</Typography>
      </Grid>
      <Grid className={classes.penaltyContainer} item xs={6}>
        { penalties[teams.visitor].map(penalty => <Penalty key={penalty.player} penalty={penalty} player={players[penalty.player]} isFlipped />) }
      </Grid>
      <Grid className={classes.penaltyContainer} item xs={6}>
        { penalties[teams.home].map(penalty => <Penalty key={penalty.player} penalty={penalty} player={players[penalty.player]} />) }
      </Grid>
    </Grid>
  )
}

export default Penalties;
